import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { LogsDataProvider } from "../../data-provider/logs.dp";
import { Utils } from "../../helper/utils.helper";

let LogsComponent = {
    selector: "vcLogs",
    templateUrl: "/angular/components/logs/logs.component.html",
    bindings: {},
    controller: class LogsController {
        private readonly $scope: any;
        private dialog: DialogUtils;
        private dataProvider: LogsDataProvider;

        public utils: Utils;
        public campaign: Campaign;
        public permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            CampaignDataProvider: CampaignDataProvider,
            DialogUtils: DialogUtils,
            LogsDataProvider: LogsDataProvider,
            Utils: Utils,
            PermissionCheck: PermissionCheck
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.dataProvider = LogsDataProvider;
            this.permissionProvider = PermissionCheck;
            this.utils = Utils;

            this.utils.accessCheck();
            this.campaign = CampaignDataProvider.activeCampaign;
            this.dataProvider.clearAll();
        }

        openViewFilterDialog(filters: object, $event: any): void {
            this.dialog.show({
                component: "vc-view-filter-dialog",
                targetEvent: $event,
                scope: this.$scope,
                clickOutsideToClose: true,
                ariaLabel: "View Person",
                locals: {
                    filters: filters,
                },
            });
        }
    },
};

angular.module("logs", []).component(LogsComponent.selector, LogsComponent);
